import { Link } from 'gatsby';
import React from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import probePicture from '../assets/on-a-table.png';
import paths from '../paths';
import Heading from './Heading';
import Modal from './Modal';

import responsiveStyles from '../styles/responsive.module.scss';

const messages = defineMessages({
  probeOnATable: {
    id: 'warrantyModal.probePicture',
    defaultMessage: 'A Butterfly iQ probe plugged into an iPhone on a table',
  },
});

const propTypes = {};

class WarrantyModal extends React.Component {
  handleAccept = () => {
    const { onAccept, onHide } = this.props;
    onAccept(true);
    onHide();
  };

  render() {
    const { intl } = this.props;

    return (
      <Modal {...this.props} closeButton center>
        <Modal.Image
          src={probePicture}
          alt={intl.formatMessage(messages.probeOnATable)}
        />
        <Modal.Body className={responsiveStyles.textAlignCenter}>
          <Heading level={2}>
            <FormattedMessage
              defaultMessage="Warranty Info"
              id="deviceWarranty.title"
            />
          </Heading>
          <p>
            <FormattedMessage
              defaultMessage="Your purchase includes a 1-year factory warranty which protects you from manufacturer's defects. The warranty does not cover accidental damage. You may extend your warranty for 2 additional years."
              id="deviceWarranty.message"
            />
          </p>
          <Link to={paths.termsAndConditions}>
            <FormattedMessage
              defaultMessage="See our full Master Terms and Conditions for details"
              id="deviceWarranty.termsLink"
            />
          </Link>
        </Modal.Body>
      </Modal>
    );
  }
}

WarrantyModal.propTypes = propTypes;

export default injectIntl(WarrantyModal);
